(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp_i"]) return;
  try {
    
  (function () {
    var root = document.querySelector('section.pdp-i');
    if (!root) return;

    // ==== SPLIDE ====
    var splideEl = root.querySelector('.splide');
    if (window.Splide && splideEl && !splideEl.splide) {
      new Splide(splideEl, {
        type: 'slide',
        rewind: true,
        arrows: true,
        pagination: true
      }).mount();
    }

    // ==== Referencias ====
    var selectEl = root.querySelector('[data-variant-select]');
    var qtyInput = root.querySelector('.quantity input.qty');
    var btnLess  = root.querySelector('.quantity .less');
    var btnPlus  = root.querySelector('.quantity .plus');
    var addBtn   = root.querySelector('[data-add-to-cart]');
    var priceEl  = root.querySelector('[data-pdp-price]');

    if (!addBtn) return;

    addBtn.classList.add('active-cart');

    // ==== Helpers ====
    function currentVariantId() {
      if (selectEl) return String(selectEl.value || '');
      return root.getAttribute('data-first-variant-id') || '';
    }

    function maxQtyForSelected() {
      if (selectEl) {
        var opt = selectEl.options[selectEl.selectedIndex];
        if (!opt) return 0;
        var inv = parseInt(opt.getAttribute('data-inventory') || '0', 10);
        inv = isNaN(inv) ? 0 : inv;
        return Math.max(0, inv);
      }
      var inv0 = parseInt(root.getAttribute('data-first-variant-inventory') || qtyInput?.getAttribute('max') || '9999', 10);
      if (isNaN(inv0)) inv0 = 9999;
      return Math.max(0, inv0);
    }

    function sanitizeQty(v) {
      var n = parseInt(v, 10);
      if (isNaN(n) || n < 1) n = 1;
      var max = maxQtyForSelected();
      if (max === 0) return 0;
      if (max > 0) n = Math.min(n, max);
      return n;
    }

    function setQty(v) {
      if (!qtyInput) return;
      var max = maxQtyForSelected();
      if (max > 0) {
        qtyInput.setAttribute('max', String(max));
        qtyInput.setAttribute('aria-valuemax', String(max));
        qtyInput.title = 'Máximo ' + max + ' en stock';
      } else {
        qtyInput.removeAttribute('max');
        qtyInput.removeAttribute('aria-valuemax');
        qtyInput.title = '';
      }
      var n = sanitizeQty(v);
      if (n === 0) n = 1;
      qtyInput.value = String(n);
      syncButtonAttrs();
    }

    function syncButtonAttrs() {
      var vid = currentVariantId();
      var q   = sanitizeQty(qtyInput ? qtyInput.value : '1');
      if (vid) addBtn.setAttribute('data-variant-id', vid);
      addBtn.setAttribute('data-qty', q > 0 ? q : 1);
      var disabled = !vid || q === 0;
      addBtn.toggleAttribute('disabled', disabled);
      if (qtyInput) {
        var cur = parseInt(qtyInput.value || '1', 10);
        var max = maxQtyForSelected();
        btnLess && (btnLess.disabled = cur <= 1);
        btnPlus && (btnPlus.disabled = (max > 0 ? cur >= max : false));
      }
    }

    function getStep() {
      return parseInt((qtyInput && qtyInput.getAttribute('step')) || '1', 10) || 1;
    }

    function goToVariantMediaFromOption(opt) {
      if (!opt || !window.Splide || !splideEl || !splideEl.splide) return;
      var mediaId = opt.getAttribute('data-media-id');
      if (!mediaId) return;
      var slides = Array.from(splideEl.querySelectorAll('[data-media-id]'));
      var idx = slides.findIndex(function (li) {
        return li.getAttribute('data-media-id') === mediaId;
      });
      if (idx >= 0) splideEl.splide.go(idx);
    }

    // ==== Subscription toggle ====
    var subRadios = root.querySelectorAll('input[name="purchase_type"]');
    var subRadioSub = root.querySelector('#pdp-sub-radio');
    
    function applySellingPlan() {
      if (!subRadios.length) return;
      
      var isSub = false;
      var sellingPlanId = '';
      var subPrice = '';
      
      subRadios.forEach(function(radio) {
        if (radio.checked && radio.value === 'subscription') {
          isSub = true;
          sellingPlanId = radio.getAttribute('data-selling-plan-id');
          subPrice = radio.getAttribute('data-selling-plan-price');
        }
      });

      if (isSub && sellingPlanId) {
        addBtn.setAttribute('data-selling-plan', sellingPlanId);
        if (priceEl && subPrice) {
          var origPrice = priceEl.getAttribute('data-original-price') || priceEl.textContent.trim();
          priceEl.setAttribute('data-original-price', origPrice);
          priceEl.innerHTML = '<s class="pdp-price-original">' + origPrice + '</s> <span class="pdp-price-sub">' + subPrice + '</span>';
        }
      } else {
        addBtn.removeAttribute('data-selling-plan');
        if (priceEl) {
          var orig = priceEl.getAttribute('data-original-price');
          if (orig) priceEl.innerHTML = orig;
        }
      }
    }

    if (subRadios.length > 0) {
      subRadios.forEach(function(radio) {
        radio.addEventListener('change', applySellingPlan);
      });
    }

    // ==== Cambio de variante ====
    selectEl && selectEl.addEventListener('change', function(){
      var opt = selectEl.options[selectEl.selectedIndex];
      if (priceEl && opt && opt.getAttribute('data-price')) {
        var newBasePrice = opt.getAttribute('data-price');
        priceEl.setAttribute('data-original-price', newBasePrice);
        priceEl.textContent = newBasePrice;
        
        // Update prices in the radio options
        var onetimePrices = root.querySelectorAll('[data-pdp-onetime-price]');
        onetimePrices.forEach(function(el) {
          el.textContent = newBasePrice;
        });
        
        // If you have a way to recalculate the subscription price dynamically based on percentage, 
        // you would update the [data-pdp-sub-price] element here as well.
        
        applySellingPlan();
      }
      goToVariantMediaFromOption(opt);
      setQty(qtyInput ? qtyInput.value : 1);
    });
    addBtn.addEventListener('mousedown', syncButtonAttrs);
    addBtn.addEventListener('touchstart', syncButtonAttrs, { passive: true });

    // ==== Inicial ====
    if (selectEl) goToVariantMediaFromOption(selectEl.options[selectEl.selectedIndex]);
    setQty(qtyInput ? (qtyInput.value || 1) : 1);
    applySellingPlan();
  })();

  } catch(e) { console.error(e); }
})();
})();
